export default __webpack_public_path__ + "static/media/flutter.643a93c8.svg";